import type { oz } from '@weft/utils';
import { created } from '../../utils/created';
import { AccountSettingsSchema } from '../account-settings/account-settings-schema';
import { NewAccountSchema } from './new-account-schema';

export const AccountSchema = created(NewAccountSchema).extend({
  settings: AccountSettingsSchema,
}).openapi('Account');

export type Account = oz.infer<typeof AccountSchema>;